import {AmplitudeButtonCategory} from "../../tracking/amplitude/track_amplitude_button_click";
import {ViewType} from "../../view_type/ViewType";
import {AmplitudeFavouriteLocation} from "./get_amplitude_favourites_event_properties";

export type FavouritesTopbarPageLocation = Extract<AmplitudeFavouriteLocation, AmplitudeButtonCategory>;

export const getFavouritesDropdownLocation = (viewType: ViewType | null): FavouritesTopbarPageLocation => {
    switch (viewType) {
        case ViewType.PROPERTY:
            return "property_page";
        case ViewType.OFFER:
            return "investment_page";
        case ViewType.HOMEPAGE:
            return "homepage";
        case ViewType.OFFER_LIST_MAP:
        case ViewType.OFFER_LIST_MAP_ABROAD:
            return "listing_map";
        default:
            return "listing_page";
    }
};

export const getFavouritesShowAllButtonCategory = (viewType: ViewType | null): AmplitudeButtonCategory => {
    return getFavouritesDropdownLocation(viewType);
};
import {AmplitudeButtonCategory} from "../../tracking/amplitude/track_amplitude_button_click";
import {ViewType} from "../../view_type/ViewType";
import {AmplitudeFavouriteLocation} from "./get_amplitude_favourites_event_properties";

export type FavouritesTopbarPageLocation = Extract<AmplitudeFavouriteLocation, AmplitudeButtonCategory>;

export const getFavouritesDropdownLocation = (viewType: ViewType | null): FavouritesTopbarPageLocation => {
    switch (viewType) {
        case ViewType.PROPERTY:
            return "property_page";
        case ViewType.OFFER:
            return "investment_page";
        case ViewType.HOMEPAGE:
            return "homepage";
        case ViewType.OFFER_LIST_MAP:
        case ViewType.OFFER_LIST_MAP_ABROAD:
            return "listing_map";
        default:
            return "listing_page";
    }
};

export const getFavouritesShowAllButtonCategory = (viewType: ViewType | null): AmplitudeButtonCategory => {
    return getFavouritesDropdownLocation(viewType);
};
